<template>
  <div class="agent-commission-wrapper">
    <div v-for="(amount, game) in parentShareGames" :key="game">
      <master-agent-share-item
        :game="game"
        :amount="amount"
        :broadcast.sync="broadcast"
        :share-amount="getExists(relateShareGames, game, null)"
        :returning="getExists(parentReturning, game, null)"
        :show="showThisGame(game)">
      </master-agent-share-item>
    </div>
  </div>
</template>
<script>
  import MasterAgentShareItem from './MasterAgentShareItem'
  export default {
    name: 'master-agent-share',
    components: {
      MasterAgentShareItem
    },
    props: {
      parentData: {
        type: Object,
        required: true
      },
      relateData: {
        type: Object,
        required: true
      },
      parentReturning: {
        // type: Object
      }
    },
    data () {
      return {
        // hidden: ['keno_classic', 'money_wheel', 'pokdeng', 'hilo_local', 'hooheyhow', 'fantan'],
        hidden: [],
        broadcast: null
      }
    },
    computed: {
      parentShareGames () {
        return this.parentData.games
      },
      relateShareGames () {
        return this.relateData.games
      }
    },
    methods: {
      getExists(object, key, defaults) {
        return _.get(object, key, defaults)
      },
      showThisGame (game) {
        return this.hidden.indexOf(game) === -1
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MasterAgentShare.vue